import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core'
import {
  NgDiagramMinimapComponent,
  NgDiagramModelService,
  NgDiagramViewportService,
} from 'ng-diagram'
import { AngularMaterialsModules } from 'src/app/module/materials.module'

const ZOOM_STEP = 0.1

@Component({
  selector: 'canvas-minimap-panel',
  imports: [NgDiagramMinimapComponent, AngularMaterialsModules],
  templateUrl: './minimap-panel.component.html',
  styleUrl: './minimap-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CanvasMinimapPanelComponent {
  private readonly modelService = inject(NgDiagramModelService)
  private readonly viewportService = inject(NgDiagramViewportService)

  protected readonly isReady = signal(false)
  protected readonly isExpanded = signal(false)

  constructor() {
    afterNextRender(() => {
      this.isReady.set(true)
    })
  }

  protected readonly canZoomIn = this.viewportService.canZoomIn
  protected readonly canZoomOut = this.viewportService.canZoomOut
  protected readonly zoomPercent = computed(
    () => Math.round(this.viewportService.scale() * 100) + '%',
  )

  protected readonly deferNodeUpdates = computed(() => this.modelService.nodes().length >= 200)

  protected zoomIn(): void {
    const currentScale = this.viewportService.scale()
    const factor = (currentScale + ZOOM_STEP) / currentScale
    this.viewportService.zoom(factor)
  }

  protected zoomOut(): void {
    const currentScale = this.viewportService.scale()
    const factor = (currentScale - ZOOM_STEP) / currentScale
    this.viewportService.zoom(factor)
  }

  protected toggleExpanded(): void {
    this.isExpanded.update(v => !v)
  }

  protected readonly keyboardShortcutsTooltip = [
    'Keyboard Shortcuts:',
    '⌘/Ctrl + S        Save',
    '⌘/Ctrl + Z        Undo',
    '⌘/Ctrl + Shift + Z  Redo',
    'Delete             Delete selected',
    '⌘/Ctrl + A        Select all',
    'Space + drag       Pan canvas',
    'Drag on canvas     Box select',
  ].join('\n')
}
